import { observer } from 'mobx-react';
import { renderPrice, renderTypePrice, renderWeightPrice, renderVariationPrice } from '@/utils/misc';

const MobilePrice = observer(({ priceDetails, productDisplayType }) => {
  const renderContent = () => {
    if (!priceDetails) return null;

    const { isWeightBased, isTypeBased, productType } = priceDetails;
    if (isWeightBased) {
      return renderWeightPrice(priceDetails, productDisplayType);
    } else if (isTypeBased) {
      return renderTypePrice(priceDetails, productDisplayType);
    } else if (productType === 'variable') {
      return renderVariationPrice(priceDetails, productDisplayType);
    } else {
      return renderPrice(priceDetails);
    }
  };

  return <>{renderContent()}</>;
});

export default MobilePrice;
